import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { AllRacksResponseModel, AllRmRacksResponseModel, CommonResponse, RackDropDownDto,  RackDropDownResponseModel,  RackResponseModel, RacksForZoneId, RmRackDropDownDto, RmRackDropDownResponseModel, RmRackResponseModel, RmZonesIdRequest } from '@gtpl/shared-models/masters';
import { ApiTags } from '@nestjs/swagger';
import { ZoneByIdDto } from './dto/zone-id-request-dto';
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import { RmRackDTO } from './dto/rm-racks.dto';
import { RmRackRequest } from './dto/rm-racks.request';
import { RmRack } from './rm-racks.entity';
import { RmRackIdRequest } from './dto/rm-rackId.request';
import { RmRacksService } from './rm-racks.service';

@ApiTags('rm-racks')
@Controller('rm-racks')
export class RmRacksController {

    constructor(
        private rackService: RmRacksService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

    @Post('/createRmRack')
    async createRmRack(@Body() rackDto:RmRackDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RmRackResponseModel> {
        try {
        return await this.rackService.createRmRack(rackDto,false,request);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(RmRackResponseModel, error);
        }
    }

    @Post('/getAllRmRacks')
    async getAllRmRacks(): Promise<AllRmRacksResponseModel> {
    try {
        return await this.rackService.getAllRmRacks();
        } catch (error) {
        return this.applicationExceptionHandler.returnException(AllRmRacksResponseModel, error);
        }
    }

    @Post('/getAllActiveRmRacks')
    async getAllActiveRmRacks(@Req() request: Request): Promise<AllRmRacksResponseModel> {
        try {
            return await this.rackService.getAllActiveRmRacks();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRmRacksResponseModel, error)
        }
    }

    /**
     * Activate Or De-Activate Value Rack
     * @param getSingleRack RackResponseModel 
     * @returns Value Rack
     */
    @Post('/activateOrDeactivateRmRack')
    async activateOrDeactivateRmRack(@Body() rackReq: RmRackRequest): Promise<RmRackResponseModel> {
        try {
            return await this.rackService.activateOrDeactivateRmRack(rackReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RmRackResponseModel, err);
        }
    }

    /**
     * creates or updates a value of Rack
     * @param RackDto Rack DTO
     * @returns RackResponse
     */
    @Post('/updateRmRack')
    async updateRmRack(@Body() rackDto:RmRackDTO,isUpdate:boolean=true,@Req() request:Request): Promise<RmRackResponseModel> {
        try {
            return await this.rackService.createRmRack(rackDto,true,request);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RmRackResponseModel, error);
        }
    }

    @Post('/getAllRmRackDropDown')
    async getAllRmRackDropDown(): Promise<RmRackDropDownResponseModel> {
        try {
            return await this.rackService.getAllRmRackDropDown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RmRackDropDownResponseModel, error);
        }
    }

    @Post('/getRmRackById')
    async getRmRackById(@Body() rackreq: RmRackRequest): Promise<RmRack> {
        try {
            return await this.rackService.getRmRackById(rackreq.rmRackId);
        } catch (err) {
            return err;
        }
    }

    @Post('/getRmRacksForZoneId')
    async getRmRacksForZoneId(@Body() rmZonesIdRequest:RmZonesIdRequest): Promise<RmRackDropDownResponseModel> {
        try {
            return await this.rackService.getRmRacksForZoneId(rmZonesIdRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RmRackDropDownResponseModel, error);
        }
    }

    @Post('/getRmRacksForZone')
    async getRmRacksForZone(@Body() zoneIdReq:ZoneByIdDto): Promise<RmRackDropDownResponseModel> {
        try {
            return await this.rackService.getRmRacksForZone(zoneIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RmRackDropDownResponseModel, error);
        }
    }

    @Post('/getRmRacksForRackId')
    async getRmRacksForRackId(@Body() rackIdRequest:RmRackIdRequest): Promise<RmRackDropDownDto> {
        try {
            return await this.rackService.getRmRacksForRackId(rackIdRequest);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RmRackDropDownDto, error);
        }
    }
    @Post('/getdummyRmRacksByZone')
    async getdummyRmRacksByZone(@Body() zoneId: RacksForZoneId): Promise<RmRackDropDownResponseModel> {
        try {
            return await this.rackService.getdummyRmRacksByZone(zoneId);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RmRackDropDownDto, error);
        }
    }
    @Post('/getAllRmRacksForPlant')
    async getAllRmRacksForPlant(@Body() plantId: PlantIdRequest): Promise<AllRmRacksResponseModel> {
        try {
            return await this.rackService.getAllRmRacksForPlant(plantId);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RmRackDropDownDto, error);
        }
    }

    @Post('/transferRmRack')
    async transferRmRack(@Body() rackDetails:any): Promise<CommonResponse> {
        try {
            return await this.rackService.transferRmRack(rackDetails);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RackDropDownDto, error);
        }
    }

}
